<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Manage Storage Types</h1>

      <p-table
        selectionMode="single"
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        (onRowSelect)="onRowSelect($event)"
        *ngIf="isLoaded; else loading"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Active</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.isActive }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="3">
              <div class="ui-helper-clearfix" style="width: 100%">
                <button
                  type="button"
                  class="btn-to-right"
                  pButton
                  icon="fa ui-icon-add"
                  (click)="showDialogToAdd()"
                  label="Add"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLE DEPRECATED --
            <p-dataTabl selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                         [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)"
                         *ngIf="isLoaded; else loading">
                <p-header>List of Storage Types</p-header>
                <p-column field="name" header="Name" [filter]="true" filterPlaceholder="Search contains" filterMatchMode="contains" [sortable]="true" [editable]="false"[style]="{'width': '45%'}"></p-column>
                <p-column field="description" header="Description" [filter]="true" filterPlaceholder="Search contains" filterMatchMode="contains" [sortable]="true" [editable]="false" [style]="{'width': '45%'}"></p-column>
                <p-column field="isActive" header="Active" [sortable]="true" [editable]="false" [style]="{'width': '10%'}"></p-column>
                <p-footer><div class="ui-helper-clearfix" style="width:100%"><button type="button" class="btn-to-right" pButton icon="fa ui-icon-add" (click)="showDialogToAdd()" label="Add"></button></div></p-footer>
            </p-dataTable>
            -->
      <p-dialog
        header="Storage Type Details"
        [(visible)]="displayDialog"
        [responsive]="true"
        [modal]="true"
      >
        <form
          [formGroup]="newStorageTypeForm"
          (ngSubmit)="save(newStorageTypeForm.value)"
          autocomplete="off"
        >
          <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="storage">
            <div class="ui-grid-row">
              <div class="ui-grid-col-4"><label for="name">Name</label></div>
              <div class="ui-grid-col-8"><input pInputText id="name" formControlName="name" /></div>
            </div>
            <div class="ui-grid-row">
              <div class="ui-grid-col-4"><label for="description">Description</label></div>
              <div class="ui-grid-col-8">
                <input pInputText id="description" formControlName="description" />
              </div>
            </div>
            <div class="ui-grid-row">
              <div class="ui-grid-col-4"><label for="isactive">Active</label></div>
              <div class="ui-grid-col-8">
                <p-checkbox name="isActive" binary="true" formControlName="isActive"></p-checkbox>
              </div>
            </div>
          </div>
          <p-footer>
            <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
              <button
                type="button"
                pButton
                icon="fa ui-icon-close"
                (click)="delete()"
                label="Delete"
              ></button>
              <button
                type="submit"
                pButton
                icon="fa ui-icon-check"
                label="Save"
                [disabled]="newStorageTypeForm.invalid"
              ></button>
            </div>
          </p-footer>
        </form>
      </p-dialog>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
